import { createFileRoute } from '@tanstack/react-router';
import { lazy } from 'react';
import { LazyComponent as LazyWrapper } from '@/components/ui';

const RepresentativeServicesPage = lazy(() => import('../pages/RepresentativeServicesPage'));

const SubstituteServicesPage = () => (
  <LazyWrapper>
    <RepresentativeServicesPage />
  </LazyWrapper>
);

export const Route = createFileRoute('/_protected/substitute/services')({
  loader: async () => {
    // const { default: i18n } = await import('../i18n');
    // await i18n.loadNamespaces?.(['duties', 'common']);
    return null;
  },
  component: SubstituteServicesPage,
});

export default Route;
